import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-colaborador-vincular-cartao-info',
  templateUrl: './colaborador-vincular-cartao-info.component.html',
  styleUrls: ['./colaborador-vincular-cartao-info.component.css']
})
export class ColaboradorVincularCartaoInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
